import React from 'react';
import {Field} from 'react-final-form';
import {FormFieldSelect} from '@yandex-data-ui/cloud-components';

import CalculatorFormLayout from 'components/calculator/CalculatorFormLayout/CalculatorFormLayout';
import {getOSProductOptions} from 'components/calculator/ComputeFormFields/utils';
import {ComputeConfig} from 'components/calculator/models';
import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';

interface OSProductFieldProps extends WithTranslationProps {
    name: string;
    osProducts: ComputeConfig['osProducts'];
}

const OSProductField: React.FC<OSProductFieldProps> = ({name, osProducts, i18nK}) => (
    <CalculatorFormLayout.Row title={i18nK('field_os')} note={i18nK('context_os')}>
        <Field name={`${name}osProduct`}>
            {(fieldProps) => (
                <FormFieldSelect {...fieldProps} size="n" items={getOSProductOptions(osProducts)} />
            )}
        </Field>
    </CalculatorFormLayout.Row>
);

export default withTranslation('calculator')(OSProductField);
